import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logo = ({ href = "/" }) => {
    const navigate = useNavigate();

    return (
        <div className="flex items-center gap-[10px]">
            <button onClick={() => navigate(href)} className="-m-1.5 p-1.5 flex items-center space-x-2"
            >
                <span className="font-semibold text-[22px] md:text-[24px] text-[#212326] tracking-[-0.5px]">
                    <span className="text-[#ff5323]">Signet</span>Print</span>
            </button>
        </div>
    );
};

export default Logo;
